import React, { useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

// CheckoutForm simplificado:
// Ya NO crea docs en pagos_pendientes — eso lo hace crearIntentoPago en la Cloud Function.
// Solo confirma el pago y redirige a /confirmacion con el payment_intent de Stripe.
// Confirmacion.js busca el ticket que el webhook ya creó.

export default function CheckoutForm({ total }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;
    setLoading(true);
    setErrorMessage(null);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/confirmacion`,
      },
    });

    // Solo llega aquí si hubo error (si el pago va bien, Stripe redirige solo)
    if (error) {
      setErrorMessage(error.message);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100">
      <h3 className="text-lg font-bold mb-4 text-gray-800">Finalizar Pago</h3>
      <PaymentElement />
      <button
        disabled={!stripe || loading}
        className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-xl mt-6 transition-all disabled:opacity-50"
      >
        {loading ? "Procesando..." : `Confirmar $${total} MXN`}
      </button>
      {errorMessage && (
        <div className="text-red-500 mt-4 text-sm font-medium">{errorMessage}</div>
      )}
    </form>
  );
}